<template>
  <div class="platform">
    <div class="platform_buttonArea">
      <el-button
        type="primary"
        @click="isPopup = 'addPlatform'"
      >添加平台</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      style="width: 100%"
      max-height="600"
    >
      <el-table-column prop="id" label="id" />
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="share_proportion" label="分成比例">
        <template slot-scope="scope">
          {{ scope.row.share_proportion }}
        </template>
      </el-table-column>
      <el-table-column prop="yonyou_share_proportion" label="用友成分比例" />
      <el-table-column prop="yonyou_merchant_code" label="用友客户档案名称" />
      <el-table-column fixed="right" label="操作" width="450">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.name == '万读'"
            class="span"
            type="text"
            @click.native.prevent="exportbut(scope.row)"
          >
            导出订单
          </el-button>
          <el-button
            v-if="scope.row.name == '触摸短剧'"
            class="span"
            type="text"
            @click.native.prevent="exportlisrwdaw(scope.row)"
          >
            导出订单
          </el-button>
          <el-button
            class="span"
            type="text"
            @click.native.prevent="myyonyou(scope.row)"
          >
            用友设置
          </el-button>
          <el-button
            class="span"
            type="text"
            @click.native.prevent="myAd(scope.row)"
          >
            平台账号
          </el-button>
          <el-button
            class="span"
            type="text"
            @click.native.prevent="
              ;(sideInputData = scope.row), (isPopup = 'datePopup')
            "
          >
            更新站点
          </el-button>
          <el-button
            class="span"
            type="text"
            @click.stop="fencheng(scope.row, 1)"
          >
            设置分成比例
          </el-button>
          <el-button
            class="span"
            type="text"
            @click.stop="fencheng(scope.row, 2)"
          >
            用友成分比例
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="isPopup" class="Mantle">
      <AddPlatform
        v-if="isPopup === 'addPlatform'"
        @close="isPopup = false"
        @determine="redundancy"
      />
      <DatePopup
        v-if="isPopup === 'datePopup'"
        :datas="sideInputData"
        :table-data="tableData"
        @determine="updateSite"
        @close="isPopup = false"
      />
    </div>
    <SideSpringFrame
      v-if="sideflag"
      ref="sideSpring"
      :column-id="columnId"
      :datas="sideInputData"
      @close="closeSide"
    />
    <yonyouMerchant_list
      v-if="sideflagyonyou"
      ref="sideSpring"
      :close="closeyonyou"
      :column-id="columnId"
      :datas="sideInputDatayonyou"
      @close="closeSideYonyou"
    />
    <el-dialog
      :title="bilidialogTitile == 1 ? '设置平台分成比例' : '设置用友分成比例'"
      :visible.sync="bilidialog"
      width="21%"
    >
      <proportion ref="vuidw" @close="close" />
    </el-dialog>
    <el-dialog
      title="时间范围选择"
      :close-on-click-modal="false"
      :visible.sync="bilidialogexport"
      width="700px"
    >
      <exportList
        ref="export"
        @close="exportClose"
        @callbackbacer="callbackbacer"
      />
    </el-dialog>

    <el-dialog
      title="导出"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      style="min-width: 680px"
    >
      <dialogExport
        ref="export"
        @determine="determine"
        @cancel="dialogVisible = false"
      />
    </el-dialog>
    <Pagination
      :total="20"
      :page.sync="tableListQuery.query"
      limit.sync="tableListQuery.pageSize"
      @pagination="redundancy"
    />
  </div>
</template>
<script>
import {
  accessplatformnew,
  chose_date_pull_data,
  order,
  chumo_reportOrder
} from '@/api/providerAccountManagement/servicePorviderList.js'
import AddPlatform from './components/addPlatform.vue'
import exportList from './components/exportList.vue'
import SideSpringFrame from './components/sideSpringFrame.vue'
import yonyouMerchant_list from './components/yonyouMerchant_list.vue'
import Pagination from '@/components/Pagination/index.vue'
import DatePopup from './components/datePopup.vue'
import proportion from './components/proportion.vue'
import dialogExport from './components/dialogExport.vue'
export default {
  name: 'AccountPlatform',
  components: {
    SideSpringFrame,
    AddPlatform,
    Pagination,
    DatePopup,
    proportion,
    yonyouMerchant_list,
    exportList,
    dialogExport
  },
  data() {
    return {
      tableListQuery: {
        page: 1,
        pageSize: 20
      },
      tableData: [],
      sideInputData: null,
      sideInputDatayonyou: null,
      side: false,
      isPopup: false,
      loading: true,
      sideflag: false,
      columnId: null,
      bilidialog: false,
      sideflagyonyou: false,
      bilidialogTitile: '',
      bilidialogexport: false,
      dialogVisible: false
    }
  },
  created() {
    this.redundancy()
  },
  methods: {
    async determine(obj) {
      this.dialogVisible = false
      const res = await chumo_reportOrder(obj)
      this.$message.success(res.data[0])
    },

    exportlisrwdaw() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.export.send()
      })
    },
    exportbut(row) {
      this.bilidialogexport = true
      this.$nextTick(() => {
        this.$refs.export.send(row)
      })
    },
    async callbackbacer(item) {
      const res = await order(item)
      if (res.code === 0) {
        this.$message.success(res.data[0])
      }
      this.exportClose()
    },
    exportClose() {
      this.bilidialogexport = false
      this.redundancy()
    },
    myAd(table) {
      this.sideflag = true
      this.side = true
      this.sideInputData = table
    },
    myyonyou(table) {
      this.sideflagyonyou = true
      this.sideInputDatayonyou = table
    },
    closeSideYonyou() {
      this.sideflagyonyou = false
    },
    closeSide() {
      this.sideflag = false
      this.side = false
    },
    async updateSite(e) {
      console.log(e)
      this.loading = true
      this.isPopup = null
      await chose_date_pull_data({
        platform_id: this.sideInputData.id,
        start_date: e[0],
        end_date: e[1],
        account_id: e[2],
        channel: e[3]
      })
      this.sideInputData = null
      this.loading = false
      this.$message({
        message: '更新成功',
        type: 'success'
      })
    },
    async redundancy() {
      this.loading = true
      const data = await accessplatformnew()
      this.tableData = data.data.data
      this.loading = false
    },
    fencheng(item, type) {
      this.bilidialog = true
      this.bilidialogTitile = type
      this.$nextTick(() => {
        this.$refs.vuidw.send(item, type)
      })
      console.log('item', item)
    },
    close() {
      this.bilidialog = false
      this.redundancy()
    },
    closeyonyou() {
      this.sideflagyonyou = false
      this.redundancy()
    }
  }
}
</script>

<style scoped lang="less">
.platform {
  width: 90%;
  margin: 0 auto;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-top: 40px;
  position: relative;
  .platform_buttonArea {
    padding: 10px 20px;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: flex-end;
  }
  .span {
    cursor: pointer;
    display: inline-block;
    color: #38a7ff;
  }
}
.Mantle {
  position: fixed;
  top: 0%;
  left: 0%;
  background-color: rgba(0, 0, 0, 0.65);
  width: 100%;
  height: 100%;
  z-index: 1111;
}

.side {
  min-width: 1000px;
  max-width: 1000px;
  min-height: 100%;
  max-height: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  right: 0px;
  -webkit-transform: translateX(1000px);
  transform: translateX(1000px);
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  z-index: 1111;
  &.active {
    transform: translateX(0px);
  }
}
.buttonexport {
  margin-top: 50px;
  position: absolute;
  // top: 50px;
  bottom: -100px;
}
</style>
